import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import AxiosService from "../services/axios.service";

const API_PATH = "users";

function AddEdit({ history, match }) {
    const { id } = match.params;
    const isAddMode = !id;

    // form validation rules 
    const validationSchema = Yup.object().shape({
        //title: Yup.string()
        //  .required('Title is required'),
        first_name: Yup.string()
            .required('First Name is required'),
        last_name: Yup.string()
            .required('Last Name is required'),
        email: Yup.string()
            .email('Email is invalid')
            .required('Email is required'),
        role: Yup.string()
            .required('Role is required'),
        reports: Yup.string()
            .required('Reports is required'),
        password: Yup.string()
            .transform(x => x === '' ? undefined : x)
            .concat(isAddMode ? Yup.string().required('Password is required') : null)
            .min(6, 'Password must be at least 6 characters'),
        confirmPassword: Yup.string()
            .transform(x => x === '' ? undefined : x)
            .when('password', (password, schema) => {
                if (password || isAddMode) return schema.required('Confirm Password is required');
            })
            .oneOf([Yup.ref('password')], 'Passwords must match')
    });

    // functions to build form returned by useForm() hook
    const { register, handleSubmit, reset, setValue, errors, formState } = useForm({
        resolver: yupResolver(validationSchema)
    });

    function onSubmit(data) {
        return isAddMode
            ? createUser(data)
            : updateUser(id, data);
    }

    function createUser(data) {
        return AxiosService.create(API_PATH, data)
            .then(() => {
                //handle email already in use
                console.log(data);
                history.push('.');
            })
    }

    function updateUser(id, data) {
        return AxiosService.update(API_PATH, id, data)
            .then(() => {
                //handle email already in use
                console.log("the big n");
                history.push('..');
            })
    }

    useEffect(() => {
        if (!isAddMode) {
            // get user and set form fields
            AxiosService.get(API_PATH, id).then(x => {
                var user = x.data;
                const fields = [/*'title', */'first_name', 'last_name', 'email', 'role', 'access', 'reports'];
                fields.forEach(field => setValue(field, user[field]));
            });
        }
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)} onReset={reset}>
            <h1>{isAddMode ? 'Add User' : 'Edit User'}</h1>
            <div className="form-row">
                {/*
                <div className="form-group col">
                    <label>Title</label>
                    <select name="title" ref={register} className={`form-control ${errors.title ? 'is-invalid' : ''}`}>
                        <option value=""></option>
                        <option value="Mr">Mr</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Miss">Miss</option>
                        <option value="Ms">Ms</option>
                    </select>
                    <div className="invalid-feedback">{errors.title?.message}</div>
                </div>*/}
                <div className="form-group col-5">
                    <label>First Name</label>
                    <input name="first_name" autoComplete="off" type="text" ref={register} className={`form-control ${errors.first_name ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.first_name?.message}</div>
                </div>
                <div className="form-group col-5">
                    <label>Last Name</label>
                    <input name="last_name" autoComplete="off" type="text" ref={register} className={`form-control ${errors.last_name ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.last_name?.message}</div>
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-7">
                    <label>Email</label>
                    <input name="email" autoComplete="off" type="text" ref={register} className={`form-control ${errors.email ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.email?.message}</div>
                </div>
                <div className="form-group col">
                    <label>Role</label>
                    <select name="role" ref={register} className={`form-control ${errors.role ? 'is-invalid' : ''}`}>
                        <option value="User">User</option>
                        <option value="Moderator">Moderator</option>
                        <option value="Admin">Admin</option>
                    </select>
                    <div className="invalid-feedback">{errors.role?.message}</div>
                </div>
                </div>
        
            <div className="form-row">
                <div className="form-group col-3">
                    <label>Page Access</label>
                    <select name="access" ref={register} className={`form-control ${errors.access ? 'is-invalid' : ''}`}>
                        <option value="Litigation">Litigation</option>
                        <option value="Investigations">Investigations</option>
                        <option value="Litigation and Investigations">Litigation and Investigations</option>
                    </select>
                    <div className="invalid-feedback">{errors.access?.message}</div>
                </div>

                <div className="form-group col-2">
                    <label>Daily Reports</label>
                    <select name="reports" ref={register} className={`form-control ${errors.reports ? 'is-invalid' : ''}`}>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                    <div className="invalid-feedback">{errors.reports?.message}</div>
                </div>
            </div>
            {!isAddMode &&
                <div>
                    <h3 className="pt-3">Change Password</h3>
                    <p>Leave blank to keep the same password</p>
                </div>
            }
            <div className="form-row">
                <div className="form-group col">
                    <label>Password</label>
                    <input name="password" autoComplete="off" type="password" ref={register} className={`form-control ${errors.password ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.password?.message}</div>
                </div>
                <div className="form-group col">
                    <label>Confirm Password</label>
                    <input name="confirmPassword" autoComplete="off" type="password" ref={register} className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.confirmPassword?.message}</div>
                </div>
            </div>
            <div className="form-group">
                <button type="submit" disabled={formState.isSubmitting} className="btn btn-primary">
                    {formState.isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                    Save
                </button>
                <Link to={isAddMode ? '.' : '..'} className="btn btn-link">Cancel</Link>
            </div>
        </form>
    );
}

export { AddEdit };